// extracted by mini-css-extract-plugin
export default {"tabs":"bLoymO2NseifghyGvNbz","tab":"Ykm51PNiOJRtl7oT77_q","active":"RumqUkhQGDC9wMrAL5D3","localidp":"adlNrEl4y0WXXnSHzaoG","mitid":"bLNYR7ir6_c3Gyyif0xG"};